import Stamp from '../Stamp'
import useTypewriter from '../../hooks/useTypewriter'
import './Hero.css'

const words = ['responsive interfaces', 'clean front-ends', 'full-stack products', 'working ideas'];

export default function Hero() {
    const typed = useTypewriter(words);

    return (
        <section className='container hero'>
            <div className='hero-kicker'>
                <span className='hero-rule'></span>
                <span>Full-Stack Developer · Front-End at Heart</span>
                <span className='hero-rule'></span>
            </div>
            <div className='hero-main'>
                <h1 className='hero-title' data-reveal>Victoria<br/><em>López</em></h1>
                <div className='hero-photo-wrap' data-reveal>
                    <figure className='hero-polaroid'>
                        <div className='hero-photo'>
                            <img src='./images/perfil.21.jpg' alt='Portrait of Maria Victoria Lopez'/>
                        </div>
                        <figcaption>— Victoria, at work</figcaption>
                    </figure>
                </div>
            </div>
            <div className='hero-tagline'>
                <p aria-label={'I transform ideas into ' + words[0]}>
                    <span className='hero-tagline-text' aria-hidden='true'>
                        <span>I transform ideas into </span>
                        <span className='hero-tagline-word'><strong>{typed}</strong><span className='hero-cursor'></span></span>
                    </span>
                </p>
            </div>
            <Stamp/>
        </section>
    )
}
